<template>
    <div class="padding_left">

        <h3 class="Shoulders600-text titulo-filtro">CATEGORIA</h3>
        <ul>
            <a @click="extraer_url()">
                <li id="2" class="text-muted text-right" @click="clasificacion('2')" data-dismiss="modal">Boletin</li>
            </a>
            <a @click="extraer_url()">
                <li id="1" class="text-muted text-right" @click="clasificacion('1')" data-dismiss="modal">Comunicado </li>
            </a>
            <a @click="extraer_url()">
                <li id="3" class="text-muted text-right " @click="clasificacion('3')" data-dismiss="modal">Todo </li>
            </a>
        </ul>
        <h3 class="Shoulders600-text titulo-filtro mt-4">ARCHIVOS</h3>

        <!-- LISTADO DE AÑOS -->
        <ul class="text-right">
            <li v-for="(annio, i) in lista_anios" :key="i">
                <router-link :to="`/prensa/vista-listado/${annio}`">
                    <span :id="annio" class="text-muted text-right" :class="{'filtroSeleccionado' : validar_anio(annio) }" @click="anio(annio)" data-dismiss="modal"> {{annio}}</span>
                </router-link>
            </li>
        </ul>

        <!-- LISTADO DE MESES -->
        <ul class="text-right">
            <hr style="margin:0">
            <li v-for="(mes_ano, p) in lista_meses" :key="p">
                <router-link :to="`/prensa/vista-listado/${anio_? anio_ : lista_anios[0]}-${mes_ano}`">
                   <span :id="mes_ano" class="text-muted text-right" :class="{'filtroSeleccionado' : validar_mes(mes_ano) }" @click="mes_anio(`${anio_? anio_ : lista_anios[0]}-${mes_ano}`)" data-dismiss="modal"> {{ string_mes(mes_ano) }} </span>
                </router-link>
            </li>
        </ul>

        <!-- LISTADO DE POST RECIENTES  -->
        <h3 class="Shoulders600-text titulo-filtro mt-4">POST RECIENTES</h3>
        <template v-if="recientes_respuesta">
            <div v-for="(item, i) in lastPost" :key="i">
                <router-link :to="`/prensa/vista-detalle/${recientes_respuesta[item-1].idarticulo}/${titularURL(recientes_respuesta[item-1].titulo)}`">
                    <div class="recientes"  @click="articulo(recientes_respuesta[item-1].idarticulo)" data-dismiss="modal">

                        <img v-if="recientes_respuesta[item-1].url_recurso" :src="recientes_respuesta[item-1].url_recurso" width="100%">
                        <!-- <img v-if="recientes_respuesta[item-1].url_thumnail" :src="recientes_respuesta[item-1].url_thumnail" width="100%"> -->
                        <img v-else src="@/assets/imagenes/sin_imagen.png" width="100%"> <!--sin_imagen.png-->
                        <p> {{recientes_respuesta[item-1].titulo}} </p>
                    </div>
                </router-link>
            </div>
        </template>

        <!-- <code> {{lista_anios}} </code>
        <hr>
        <code> {{lista_meses}} </code>
        <hr>

        <div v-if="recientes_respuesta">
            <code v-for="(item, i) in 3" :key="i">
                {{recientes_respuesta[item-1]}}
                <hr>
            </code>
        </div> -->
    </div>
</template>

<script>
import axios from "axios"
import { mapState } from "vuex";
import { mapMutations } from 'vuex'
export default {
    data: function(){
        return {
           url: this.$urlServidor+'SalaDePrensa/api/api/Sala/',
           datos: null,
           lista_anios: [],
           //lista_anio: [2021, 2020, 2019, 2018],
           meses_respuesta: null,
           lista_meses: [],
           recientes_respuesta: null,
           filtro_anio_actual: 0,
           lastPost: 0
        }
    },
    computed:{
        ...mapState(['tipo', 'anio_', 'mes_ano', 'post', 'anio_actual', 'articulo_actual', 'vista_listado', 'vista_detalle']),

    },
    methods:{
        ...mapMutations(['anio', 'clasificacion', 'mes_anio', 'articulo', 'add_anio', 'add_articulo']),


        //  Extraer_url() = CAMBIA URL A VISTA-LISTADO (CUANDO ESTA EN VISTA-DETALLE)
        //  PASA 0, A AÑO, PARA QUE NO TOME EL ULTIMO AÑO Q SE BUSCO, SINO Q HAGA ---
        //  UNA CONSULTA AL AÑO MAS RECIENTE CON ARTICULOS----------------------------
        extraer_url(){ if(!this.vista_listado){
                this.anio(0);
                this.$router.push({name: 'listado'});
            }
        },



        string_mes(mes){
            if(mes==1) return 'Enero'; if(mes==2) return 'Febrero'; if(mes==3) return 'Marzo'; if(mes==4) return 'Abril';
            if(mes==5) return 'Mayo'; if(mes==6) return 'Junio'; if(mes==7) return 'Julio'; if(mes==8) return 'Agosto';
            if(mes==9) return 'Septiembre'; if(mes==10) return 'Octubre'; if(mes==11) return 'Noviembre'; if(mes==12) return 'Diciembre';
        },

        /** entra una cadena, ejm: 'titular de prensa', reemplaza espaciados
        * @returns 'titular-de-prensa'
        */
        titularURL(titulo){
            let tituloNuevo = titulo;
            let huboEspacio = true;

            while(huboEspacio){
                if(tituloNuevo.indexOf(' ') > 0){
                    tituloNuevo = tituloNuevo.replace(' ', '-');
                }
                else huboEspacio = false;
            }
            return tituloNuevo;

        },


        //  ESTA FUNCION HACE LA CONSULTA, TRAER AÑOS CON ARTICULO.
        //  LA DE anios_listado() LIMPIA AÑOS REPETIDOS.
        traerAnios(){
             axios.get(this.url+'Anios')
            .then(response => {
                this.datos = response.data;
                this.anios_listado();
                this.post_recientes();
                this.add_anio(this.datos[0].anio);
            })
            .catch(function (error) { console.log(error) });
        },

        anios_listado(){
            for(var i in this.datos){
                if(!this.lista_anios.includes(this.datos[i].anio)){
                    this.lista_anios.push(this.datos[i].anio);
                }
            }
           this.traerMeses();
        },


        //  ESTA FUNCION HACE LA CONSULTA, TRAER MESES DEL AÑO, CON ARTICULO.
        //  LA DE meses_listado() LIMPIA MESES REPETIDOS.
        traerMeses(){
            if(this.anio_ > 0){
                var anio_consulta = this.anio_;

            }else if(this.$route.params.filtros){
                 if(this.$route.params.filtros.length > 4){
                    var anio_consulta = this.$route.params.filtros.substr(0,4);
                 }else{
                    var anio_consulta = this.$route.params.filtros;
                 }
            }
            else{
                var anio_consulta = this.lista_anios[0];
            }

            // si anio_ tiene algo ese es el año de consulta, sino consulta el año mas reciente
            // var anio_consulta = this.anio_? this.anio_ : this.lista_anios[0] ;

            axios.get(this.url+'Meses/'+anio_consulta)
            .then(response =>  {
                this.meses_respuesta = response.data;
                this.meses_listado()
            })
            .catch(function (error) { console.log(error) });
        },


        meses_listado(){
            for(var i in this.meses_respuesta){
                if(!this.lista_meses.includes(this.meses_respuesta[i].idmes)){
                    this.lista_meses.push(this.meses_respuesta[i].idmes);
                }
            }

        },



        // ESTA FUNCION HACE LA CONSULTA, TRAER AÑO MAS RECIENTE CON ARTICULOS.
       post_recientes(){

           axios.get(this.url+'Articulos/'+this.lista_anios[0])
            .then(response => {
                this.recientes_respuesta = response.data;
                let obj = {
                    id: this.recientes_respuesta[0].idarticulo,
                    titulo: this.recientes_respuesta[0].titulo
                }
                this.lastPost = (this.recientes_respuesta.length <3)? this.recientes_respuesta.length : 3;
                this.add_articulo(obj);
                // console.log(this.recientes_respuesta + ' <---respuesta recientes');
            })
            .catch(function (error) {
                console.log(error);
            });
       },


        // COLOCA LOS ESTILOS AL FILTRO CATEGORIA SELECCIONADO
        pintarFiltroTipo(n){
            for(var i=1; i<=3; i++){
                if(n == i) document.getElementById(i).className = 'text-muted text-right filtroSeleccionado';
                else document.getElementById(i).className = 'text-muted text-right';
            }
        },



        //  SI ESTAMOS PARADOS EN VISTA-LISTADO, SI LA RUTA TRAE UN FILTRO, Y SI FILTRO VIENE CON MES
        //     OBTIENE EL AÑO, LO COMPARA HASTA ENCONTRARLO.
        //   SINO, SI EL FILTRO SOLO TRAE EL AÑO, LO COMPARA HASTA ENCONTRARLO.
        //   SINO, SI LA RUTA VIENE SIN FILTRO, COMPARA EL AÑO MAS RECIENTE CON ARTICULOS HASTA ENCONTRARLO.
        validar_anio(valor){
            if(this.vista_listado){
                if(this.$route.params.filtros){
                    if(this.$route.params.filtros.length > 4){
                        var anio = this.$route.params.filtros.substr(0,4)
                        return (anio == valor)? true : false;
                    }
                    else{
                        return (this.$route.params.filtros == valor)? true : false;
                    }
                }else{
                    return (this.lista_anios[0] == valor)? true : false;
                }
            }
        },



        //   SI ESTAMOS PARADOS EN VISTA-LISTADO, SI LA RUTA TRAE UN FILTRO, Y SI FILTRO VIENE CON MES
        //       OBTIENE EL MES, LO COMPARA HASTA ENCONTRARLO.
        validar_mes(valor){
            if(this.vista_listado){
                if(this.$route.params.filtros){
                    if(this.$route.params.filtros.length > 4){
                        var mes  = this.$route.params.filtros.substr(5);
                        return (mes == valor)? true : false;
                    }
                }
            }

        },

      },
    created(){
        this.traerAnios();
    },
    mounted(){

    },

    watch:{
        anio_: function(){
        // limpio los meses para q no los acumule
             this.lista_meses = [];
             this.traerMeses();

        },
        tipo: function(){
            this.pintarFiltroTipo(this.tipo)
        },
        mes_ano: function(){
        },
        post: function () {
            window.scrollTo(0, 0);
        }

        /* ---- DESACTIVO EL FILTRO DE CLASIFICACION EN VISTA DETALLE ---- */
        // vista_detalle: function(){
        //     for(var i=1; i<=3; i++){ document.getElementById(i).className = 'text-muted text-right'; }
        // }

    }


}
</script>

<style scoped>
    .titulo-filtro{
        color: #868686;
        text-align: right;
        border-bottom: 3px solid #868686;
    }

    ul li {  list-style:none; }

    ul a {cursor: pointer;}

    .recientes{
        width: 100%;
        opacity: .7;
        font-family: 'Big Shoulders Display', cursive; font-weight: 400;
    }
    .recientes:hover{ opacity: .8; }
    .filtroSeleccionado{
        text-decoration: underline;
        font-weight: 900;
    }

    a { color: #3d3d3d; letter-spacing: 1.1px; }
    a:hover { color: #343a40; }


</style>
